import { render, staticRenderFns } from "./FlowBoard.vue?vue&type=template&id=066b65e1&scoped=true&"
import script from "./FlowBoard.vue?vue&type=script&lang=js&"
export * from "./FlowBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b65e1",
  null
  
)

export default component.exports